var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 111,
    viewBox: "0 0 118 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3594 109.698L31.858 105.383",
    stroke: "#807F7E",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86719 88.2725L12.195 85.7812",
    stroke: "#807F7E",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 59H4.99729",
    stroke: "#807F7E",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86719 29.7266L12.195 32.2178",
    stroke: "#807F7E",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3594 8.29688L31.858 12.6118",
    stroke: "#807F7E",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7188 0.453125V5.43558",
    stroke: "#807F7E",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0768 8.29688L85.5781 12.6118",
    stroke: "#807F7E",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.57 29.7266L105.242 32.2178",
    stroke: "#807F7E",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.435 59H112.438",
    stroke: "#807F7E",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109.57 88.2725L105.242 85.7812",
    stroke: "#807F7E",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0768 109.698L85.5781 105.383",
    stroke: "#807F7E",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8828 106.359L26.3515 104.344",
    stroke: "#807F7E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1094 102.5L21.7813 100.648",
    stroke: "#807F7E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7578 98.167L17.6147 96.5",
    stroke: "#807F7E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8906 93.4096L13.9121 91.9453",
    stroke: "#807F7E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75781 82.8101L8.04044 81.7969",
    stroke: "#807F7E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55469 77.0901L5.93104 76.3203",
    stroke: "#807F7E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96094 71.1664L4.40498 70.6484",
    stroke: "#807F7E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1 65.1198L3.48495 64.8594",
    stroke: "#807F7E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1 52.875L3.48495 53.1354",
    stroke: "#807F7E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96094 46.8281L4.40498 47.3461",
    stroke: "#807F7E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55469 40.9062L5.93104 41.6761",
    stroke: "#807F7E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75781 35.1875L8.04044 36.2008",
    stroke: "#807F7E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8906 24.5859L13.9121 26.0502",
    stroke: "#807F7E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7578 19.8203L17.6147 21.4873",
    stroke: "#807F7E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1094 15.4922L21.7813 17.3435",
    stroke: "#807F7E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8828 11.6328L26.3515 13.6483",
    stroke: "#807F7E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5156 5.51562L36.5319 7.79148",
    stroke: "#807F7E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 3.32031L42.0221 5.68961",
    stroke: "#807F7E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1875 1.73438L47.707 4.17116",
    stroke: "#807F7E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2578 0.773438L53.519 3.25102",
    stroke: "#807F7E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5346 0.773438L65.2734 3.25102",
    stroke: "#807F7E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6054 1.73438L71.0859 4.17116",
    stroke: "#807F7E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5377 3.32031L76.7656 5.68961",
    stroke: "#807F7E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2819 5.51562L82.2656 7.79148",
    stroke: "#807F7E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M93.914 11.6328L92.4453 13.6483",
    stroke: "#807F7E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6875 15.4922L97.0156 17.3435",
    stroke: "#807F7E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M103.029 19.8203L101.172 21.4873",
    stroke: "#807F7E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M106.904 24.5859L104.883 26.0502",
    stroke: "#807F7E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M113.04 35.1875L110.758 36.2008",
    stroke: "#807F7E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M115.244 40.9062L112.867 41.6761",
    stroke: "#807F7E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M116.835 46.8281L114.391 47.3461",
    stroke: "#807F7E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M117.79 52.875L115.305 53.1354",
    stroke: "#807F7E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M117.79 65.1198L115.305 64.8594",
    stroke: "#807F7E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M116.835 71.1664L114.391 70.6484",
    stroke: "#807F7E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M115.244 77.0901L112.867 76.3203",
    stroke: "#807F7E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M113.04 82.8101L110.758 81.7969",
    stroke: "#807F7E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M106.904 93.4096L104.883 91.9453",
    stroke: "#807F7E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M103.029 98.167L101.172 96.5",
    stroke: "#807F7E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6875 102.5L97.0156 100.648",
    stroke: "#807F7E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M93.914 106.359L92.4453 104.344",
    stroke: "#807F7E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuage);
export default __webpack_public_path__ + "static/media/guage.5a98e6c9f1e5509d99bdbe81a7380e1b.svg";
export { ForwardRef as ReactComponent };